import React from "react"
import { t } from "../../i18n"

const ResetPasswordLink = (): JSX.Element => {
  return <a href="../password/new" id="lnk_reset_password">{t("landing.login.forgot")}</a>
}

export default ResetPasswordLink
